/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-tag-spacing */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react';
import { Skeleton } from 'react-skeleton-generator';

function UpdateOfferSkeleton() {
    return (
        <Skeleton.SkeletonThemeProvider>
            <div className="flex mt-3.5 -mx-2">
                <div className="px-2 w-1/3">
                    <div className="relative">
                        <Skeleton/>
                        <label for="offercode" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Offer Code
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                </div>
                <div className="px-2 w-1/3">
                    <div className="dropdown relative">
                        <Skeleton/>
                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Offer Type
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </p>
                    </div>
                </div>
                <div className="px-2 w-1/3">
                    <div className="relative">
                        <Skeleton/>
                        <label for="offercode" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Offer Tag
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                </div>
            </div>
            <p className="text-[#555259] text-xs2 font-semibold my-5">Applicable Distributors</p>
            <div className="flex -mx-1 mt-3.5 items-center">
                <div className="px-1 w-1/3">
                    <div className="dropdown relative">
                        <Skeleton/>
                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Distributor 1
                        </p>
                        <img src="images/close-icon.svg" alt="icon" className="absolute top-[22px] right-3 hidden close-icon cursor-pointer" />

                    </div>
                </div>
                <div className="px-1 w-1/3 hidden product2">
                    <div className="dropdown relative">
                        <Skeleton/>
                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Distributor 2
                        </p>
                        <img src="images/close-icon.svg" alt="icon" className="absolute top-[22px] right-3 hidden close-icon1 cursor-pointer" />

                    </div>
                </div>
            </div>
            <div className="mt-5 relative">
                <Skeleton height="100px"/>
                <label for="description" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Description</label>
            </div>
            <div className="mt-5 flex -mx-2">
                <div className="px-2 w-1/3">
                    <div className="dropdown relative">
                        <Skeleton/>
                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Type
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </p>
                    </div>
                </div>
                <div className="px-2 w-1/3">
                    <div className="relative">
                        <Skeleton/>
                        <label for="offercode12" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            Start Date
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                </div>
                <div className="px-2 w-1/3">
                    <div className="relative">
                        <Skeleton/>
                        <label for="offercode11" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                            End Date
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="mt-8 w-full">
                <h5 className="text-sm font-bold text-[#090406]">Criteria</h5>
                <div className="mt-2 rounded-[22px] bg-[#F5F5FA] px-2.5 pt-8 w-full">
                    <div>
                        <p className="text-sm font-bold text-[#090406] pt-1.5 px-[22px] pb-1">Criterion </p>
                        <div className="bg-[#ffffff] rounded-[16px] px-[22px] pt-4 pb-3.5">
                            <div className="w-[90%]">
                                <p className="text-[#090406] font-bold text-sm">Offer Parameter</p>
                                <div className="mt-5 flex">
                                    <div className="w-[46%] px-3 flex justify-start">
                                        <Skeleton width="150px"/>
                                    </div>
                                    <div className="tab-content w-full" id="pills-tabContentVertical">
                                        <div className="tab-pane fade show active w-full" id="home10" role="tabpanel" aria-labelledby="pill10">
                                            <div className="flex">
                                                <div className="w-full px-[6px] relative">
                                                    <Skeleton/>
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-4 bg-[#FFFFFF] px-1">Minimum Quantity</p>
                                                </div>
                                                <div className="w-full pl-[6px] relative">
                                                    <Skeleton/>
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-4 bg-[#FFFFFF] px-1">Maximum Quantity</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex -mx-[6px] pt-8">
                                    <div className="w-1/3 px-[6px]">
                                        <div className="border border-[#D8DDE3] rounded-lg h-[50px] w-full relative p-3">
                                            <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-2.5 bg-[#FFFFFF] px-1">
                                                Trade Discount
                                                {' '}
                                                <span className="text-[#ED1C24]">*</span>
                                            </p>
                                            <div className="flex">
                                                <Skeleton/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-1/3 px-[6px]">
                                        <div className="border border-[#D8DDE3] rounded-lg h-[50px] w-full relative p-3">
                                            <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-2.5 bg-[#FFFFFF] px-1">
                                                Additional Discount
                                                <span className="text-[#ED1C24]">*</span>
                                            </p>
                                            <div className="flex">
                                                <Skeleton/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-1/3 px-[6px] relative">
                                        <div className="relative">
                                            <Skeleton/>
                                        </div>
                                        <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-4 bg-[#FFFFFF] px-1">Maximum Discount</p>
                                    </div>
                                </div>
                                <div className="">
                                    <p className="text-[#090406] font-bold text-sm py-8">Product Parameter</p>
                                    <div className="flex -mx-1 mt-3.5 items-center">
                                        <div className="px-1 w-1/3">
                                            <div className="dropdown relative">
                                                <button type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Main Category
                                                        {' '}
                                                        <span className="text-[#ED1C24]">*</span>
                                                    </p>
                                                    <Skeleton/>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="px-1 w-1/3">
                                            <div className="dropdown relative">
                                                <button type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Category
                                                    </p>
                                                    <Skeleton/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex -mx-1 mt-3.5">
                                        <div className="px-1 w-1/3">
                                            <div className="dropdown relative">
                                                <button type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Sub Category 1
                                                    </p>
                                                    <Skeleton/>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="px-1 w-1/3">
                                            <div className="dropdown relative">
                                                <button type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Sub Category 2
                                                    </p>
                                                    <Skeleton/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="-mx-1 mt-3.5">
                                        <div className="px-1 w-full">
                                            <div className="dropdown relative">
                                                <button type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                                    <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                        Product(s)
                                                    </p>
                                                    <Skeleton/>
                                                </button>
                                            </div>

                                            <p className="text-sm font-semibold text-[#555259] mt-7 add-product-parameter cursor-pointer">+ Add Product Parameter</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="flex justify-center">
                        <button className="my-2.5 w-[152px] h-[38px] bg-[#555259] text-xs6 font-bold text-[#FFFFFF] rounded-lg add-creation add-creation2">
                            <Skeleton/>
                        </button>
                    </div>
                </div>
                <div className="mt-4 mb-8 flex justify-center">
                    <button className="w-[235px] h-[38px] bg-[#555259] text-xs6 font-bold text-[#FFFFFF] rounded-lg create-deal">
                        <Skeleton/>
                    </button>
                </div>
            </div>

        </Skeleton.SkeletonThemeProvider>

    );
}

export default UpdateOfferSkeleton;
